<style lang="css" scoped>

</style>

<template>

  <v-flex d-flex align-center class="px-2" v-if="devmode">
    <v-flex xs3>
      <v-flex d-flex align-center>
        <h3 class="text-nowrap">{{content.threshold}} :</h3>
      </v-flex>
    </v-flex>
    <v-flex xs9 class="text-xs-right">
      <v-form  @submit.prevent="updateThreshold()">
        <v-flex d-flex align-center row nowrap class="text-xs-right">
          <v-flex d-flex grow>
            <v-text-field type="number" v-model="edit" ref="thresholdInput" @focus="focusedOnThreshold()" @blur="quitEditThreshold()">
              <template v-slot:label>
                <span dir="ltr">{{threshold}} <strong>{{icon}}</strong></span>
              </template>
            </v-text-field>
          </v-flex>
          <div class="mt-0 text-xs-right" style="flex: 0!important;">
            <v-btn small :color="btn.color" :loading="loading" icon fab @click="startEditThreshold()" class="white--text">
              <v-icon size="20">{{btn.icon}}</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-form>
    </v-flex>
  </v-flex>

</template>

<script>

import { mapGetters } from 'vuex'
export default {
    props: ['locale'],
    data() {
        return {
          slug: this.$route.params.slug,
          edit: null,
          loading: null,
          icons: {
            'temp': '℃',
            'humidity': '%',
            'light': 'lx'
          },
          icon: '',
          btn: {
            color: 'blue',
            icon: 'edit',
          }
        }
    },
    created() {
      this.setLang();
      if (this.devmode) {
        this.updateThresholdIcon();
      }
    },
    computed: {
       ...mapGetters(['devices/device']),
      devmode: function (getter) {
        this.loading = null
        return getter['devices/device'](this.$route.params.slug).data.devmode;
      },
      threshold: function (getter) {
        this.loading = null
        let device = getter['devices/device'](this.$route.params.slug)
        if (!device.type) {
          return device.data.switch1threshold;
        } else if (device.type == 2) {
          return device.data.threshold;
        }
      }
    },
    watch: {
      threshold(){
        if (this.threshold == this.edit) {
          this.edit = null;
          this.quitEditThreshold();
        }
      },
      devmode(){
        this.updateThresholdIcon()
      },
    },
    methods: {
        updateThresholdIcon() {
            switch (this.devmode) {
                case 1:
                case 2:
                    this.icon = this.icons.temp
                    break;
                case 3:
                case 4:
                    this.icon = this.icons.humidity
                    break;
                case 5:
                case 6:
                    this.icon = this.icons.light
                    break;
            }
        },
        startEditThreshold() {
            if (this.btn.color === 'green' && this.edit) {
                this.updateThreshold();
            } else {
                this.$refs.thresholdInput.focus();
            }
        },
        focusedOnThreshold(){
          this.btn = {
              color: 'green',
              icon: 'done'
          };
        },
        quitEditThreshold() {
          if (this.devmode) {
            if (this.$refs.thresholdInput) {
              this.$refs.thresholdInput.blur();
            }
            let thres = this.edit;
            if (!thres) {
              this.btn = {
                color: 'blue',
                icon: 'edit'
              };
            }
          }
        },
        updateThreshold() {
          let thres = this.edit;
          if (thres) {
            this.loading = true;
            let data = {
              slug: this.slug,
              modify:{
                parameter: 'threshold',
                value: thres,
              }
            }
            this.$store.dispatch('devices/modifyDevice', data);
          }
        },

        setLang() {
          if (this.locale == "en") {
              this.content = {
                  threshold: 'Threshold',
              };

          } else if (this.locale == "he") {
              this.content = {
                  threshold: 'סף',
              };
          }
        },
    }
}

</script>
